import { render, staticRenderFns } from "./UploadRowAddDZ.vue?vue&type=template&id=18c448bd&scoped=true"
import script from "./UploadRowAddDZ.vue?vue&type=script&lang=js"
export * from "./UploadRowAddDZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c448bd",
  null
  
)

export default component.exports